import type { ProjectRole } from "@/types/models";

export interface ProjectRoleDefinition {
  value: ProjectRole;
  label: string;
  audience: "internal" | "client" | "both";
  description: string;
}

export const PROJECT_ROLE_DEFINITIONS: readonly ProjectRoleDefinition[] = [
  {
    value: "owner",
    label: "Project owner",
    audience: "internal",
    description:
      "Full control of this project while it is active or completed: settings and schedule, participants and roles, Internal and Shared work, reports, templates, and archiving. Restoring an archived project requires a workspace administrator.",
  },
  {
    value: "internal_member",
    label: "Internal member",
    audience: "internal",
    description:
      "Can view and change Internal and Shared project work and comment. Cannot manage settings, participants, roles, audience, reports, templates, or project closure.",
  },
  {
    value: "client_lead",
    label: "Client lead",
    audience: "client",
    description:
      "Can view and change Shared project work, comment, and create Shared reports. Cannot see Internal work or manage project settings, participants, roles, or audience.",
  },
  {
    value: "client_member",
    label: "Client member",
    audience: "client",
    description:
      "Can view and change Shared project work and comment. Cannot see Internal work, create reports, or manage project settings, participants, roles, or audience.",
  },
  {
    value: "observer",
    label: "Observer",
    audience: "both",
    description:
      "Can view Shared project work only. Cannot see Internal work, comment, make changes, or create reports.",
  },
] as const;

export function projectRoleDefinition(role: ProjectRole) {
  const currentRole = role === "internal_editor" ? "internal_member" : role;
  return PROJECT_ROLE_DEFINITIONS.find(
    (definition) => definition.value === currentRole,
  )!;
}

export function projectRoleOptions(kind: "internal" | "client") {
  return PROJECT_ROLE_DEFINITIONS.filter(
    (definition) =>
      definition.audience === kind || definition.audience === "both",
  );
}
